import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EMDMICONS } from '../constants/icon-pack.constant';

@Component({
  selector: 'app-content-popup',
  templateUrl: './content-popup.component.html',
  styleUrl: './content-popup.component.scss'
})
export class ContentPopupComponent {
  @Output() closeContentPopUp = new EventEmitter<boolean>;

  @Input() dialogTitle: string = "";

  @Input() width = 800;
  @Input() height = 650;
  
  @Output() contentSelected = new EventEmitter<any>();

  iconPacks = EMDMICONS;
  closePopup(value: boolean) {
    this.closeContentPopUp.emit(value);
  }
}
